import React from 'react';
import colors from '../../../Theming/colors';
import { SvgProps, useDefaultColor } from '../core';

const LinkedInLogo: React.FC<SvgProps> = ({
  width = 25,
  height = 25,
  className,
  color = colors.smokeyWhite,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12.5 0C5.598 0 0 5.598 0 12.5S5.598 25 12.5 25 25 19.402 25 12.5 19.402 0 12.5 0zM8.868 18.896H5.823V9.739h3.045v9.159zM7.346 8.486h-.02c-1.022 0-1.683-.702-1.683-1.581 0-.899.681-1.583 1.723-1.583 1.041 0 1.682.684 1.702 1.583 0 .879-.66 1.582-1.722 1.582zm12.499 10.41H16.8v-4.9c0-1.23-.44-2.07-1.542-2.07-.841 0-1.342.566-1.562 1.113-.08.196-.1.469-.1.743v5.114h-3.045s.04-8.3 0-9.158h3.045v1.296c.404-.624 1.128-1.511 2.743-1.511 2.003 0 3.505 1.309 3.505 4.122v5.252z"
        fill={useDefaultColor(color)}
      />
    </svg>
  );
};

export default LinkedInLogo;
